<template>
    <div class="row">
        <div class="mb-3">
            <div class="hstack align-items-start gap-3">
                <div class="me-auto">
                    <Breadcrumb v-if="breadcrumbItems && !props.overrideActiveFolder" :breadcrumb-items="breadcrumbItems" @itemClick="onBreadcrumbItemClick" />
                </div>

              <div class="flex-container">
                <div class="flex-item"><SpacesSelector @space-change="spaceChange" /></div>
                <div class="flex-item">
                  <Button
                      v-if="!slideLibraryChooser || lpiUser"
                      severity="info"
                      @click="openUploadFileDialog = true"
                      v-tooltip.bottom="{ value: slideLibraryActive ? 'Save Slide to Library' : 'Upload File', showDelay: 500, hideDelay: 100 }">
                    <IconUpload />
                  </Button>
                </div>
                <div class="flex-item">
                  <Button
                      v-if="!slideLibraryChooser || lpiUser"
                      severity="info"
                      @click="openCreateFolderDialog = true"
                      v-tooltip.bottom="{ value: 'Create New Folder', showDelay: 500, hideDelay: 100 }">
                    <IconFolderPlus />
                  </Button>
                </div>
              </div>

<!--                  <b-button @click="toggleFormFactor" variant="outline-secondary">-->
<!--                    <i v-if="resultsFormFactor === 'grid'" class="fas fa-th"></i>-->
<!--                    <i v-if="resultsFormFactor === 'list'" class="fas fa-list"></i>-->
<!--                  </b-button>-->
                </div>
            </div>
        </div>

  <Dialog v-model:visible="openOverwriteDialog">
    <OverwriteConfirmDialog :uploadTarget="uploadTarget"  @update-upload-target="closeOverwriteDialog" @file-uploaded="closeOverwriteDialog" :upload-directory-id="getFolder().id" :parent-folder="getFolder().name" :breadcrumb-items="breadcrumbItems" :space="space"/>
  </Dialog>

  <Dialog v-model:visible="openUploadFileDialog" :header="slideLibraryActive ? 'Add Slide to Library' : 'Upload File'" :style="{ width: '50rem' }">
    <AddSlideDialog v-if="slideLibraryActive" @tempFiles="tempFiles" @file-uploaded="closeUploadFileDialog" @close-dialog="closeUploadFileDialog" :upload-directory-id="getFolder().id" :parent-folder="getFolder().name" :breadcrumb-items="breadcrumbItems" :space="space"/>
    <UploadDialog v-else @file-uploaded="closeUploadFileDialog" @tempFiles="tempFiles" :upload-directory-id="getFolder().id" :parent-folder="getFolder().name" :breadcrumb-items="breadcrumbItems" :space="space"/>
  </Dialog>

  <Dialog v-model:visible="openCreateFolderDialog" :header="`Create New Folder in ${getFolder().name}`" :style="{ width: '50rem' }">
    <CreateFolderDialog @folder-created="closeCreateFolderDialog" :parent-folder="getFolder()" :space="space"/>
  </Dialog>

</template>

<script setup>
import {ref, watch, defineProps, defineEmits, onMounted, computed} from 'vue';
import Breadcrumb from '../../Breadcrumb.vue';
import CreateFolderDialog from "../CreateFolderDialog.vue";
import UploadDialog from "../UploadDialog.vue";
import AddSlideDialog from "../AddLibrarySlide.vue";
import SpacesSelector from "./SpacesSelector.vue";
import OverwriteConfirmDialog from "../OverwriteConfirmDialog.vue";
import {useMainStore, useAuthStore} from "@/store/index.ts";
import {storeToRefs} from "pinia";

const props = defineProps({
  title: {
    type: String,
    required: true
  },
  showFormFactorSelector: {
    type: Boolean,
    default: true
  },
  enableSearch: {
    type: Boolean,
    default: false
  },
  resultsSearchQuery: String,
  resultsFormFactor: {
    type: String,
    default: 'grid',
    validator: value => ['grid', 'list'].includes(value)
  },
  breadcrumbItems: Array,
  uploadTarget: Object,
  overrideActiveFolder: Boolean
});

const mainStore = useMainStore()
const authStore = useAuthStore()

const {slideLibraryActive, slideLibraryChooser,} = storeToRefs(mainStore)
const {lpiUser} = storeToRefs(authStore)

const emit = defineEmits(['space-change',
  'breadcrumbItemClick', 'update-upload-target',
  'update:resultsSearchQuery', 'update:resultsFormFactor',
  'folder-created', 'update:files', 'file-uploaded', 'temp-files']);



const i18n = {
  search: 'Search'
};



const searchText = ref('');
const space = ref('main');
const openUploadFileDialog = ref(false)
const openCreateFolderDialog = ref(false)
const openOverwriteDialog = ref(false)


watch(() => props.uploadTarget, (newVal) => {
  openOverwriteDialog.value = !!newVal;
});



const closeOverwriteDialog = () => {
  openOverwriteDialog.value = false;
  emit('update-upload-target');
  emit('file-uploaded')
}

const spaceChange = (space) => {
  space.value = space;
  emit('space-change', space);
};

const getFolder = () => {
  return props.breadcrumbItems && props.breadcrumbItems.length > 0 ? props.breadcrumbItems[props.breadcrumbItems.length - 1] : { name: "Home" };
};

const closeUploadFileDialog = () => {
 openUploadFileDialog.value = false
  emit('file-uploaded')
};

const tempFiles = (file) => {
  emit('temp-files', file)
}

const closeCreateFolderDialog = () => {
  openCreateFolderDialog.value = false
  emit('folder-created')
};

const search = () => {
  emit('update:resultsSearchQuery', searchText.value);
};

const toggleFormFactor = () => {
  emit('update:resultsFormFactor', props.resultsFormFactor === 'grid' ? 'list' : 'grid');
};

const onBreadcrumbItemClick = (item) => {
  emit('breadcrumbItemClick', item && item.id ? item.id : '');
};

watch(() => props.resultsSearchQuery, (value) => {
  searchText.value = value;
});



onMounted(() => {
  if (window.ccmi18n_filemanager) {
    for (const key in i18n) {
      if (window.ccmi18n_filemanager[key]) {
        i18n[key] = window.ccmi18n_filemanager[key];
      }
    }
  }

});
</script>

<style>
.hstack.align-items-start.gap-3 {
  font-size: 1rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  -webkit-text-size-adjust: 100% !important;
  -webkit-tap-highlight-color: rgba(0,0,0,0) !important;
  color: inherit !important;
  --bs-gutter-x: 1.5rem !important;
  --bs-gutter-y: 0 !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: row !important;
  align-self: stretch !important;
  gap: 1rem!important;
  align-items: flex-start!important;
}

.mb-3 {
  font-size: 1rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  -webkit-text-size-adjust: 100% !important;
  -webkit-tap-highlight-color: rgba(0,0,0,0) !important;
  color: inherit !important;
  --bs-gutter-x: 1.5rem !important;
  --bs-gutter-y: 0 !important;
  box-sizing: border-box !important;
  flex-shrink: 0 !important;
  width: 100% !important;
  max-width: 100% !important;
  padding-right: calc(var(--bs-gutter-x)*0.5) !important;
  padding-left: calc(var(--bs-gutter-x)*0.5) !important;
  margin-top: var(--bs-gutter-y) !important;
  margin-bottom: 1rem!important;
}

.me-auto {
  font-size: 1rem !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  -webkit-text-size-adjust: 100% !important;
  -webkit-tap-highlight-color: rgba(0,0,0,0) !important;
  color: inherit !important;
  --bs-gutter-x: 1.5rem !important;
  --bs-gutter-y: 0 !important;
  box-sizing: border-box !important;
  margin-right: auto!important;
}

.flex-container {
  display: flex;
  align-items: center;
  justify-items: center;
}

.flex-item {
  margin-right: 10px;
}

.modal-open div[id^='modal-'] {
  .btn-outline-secondary {
    margin: 2px;
    background-color: #e9ecef;
    border: #e9ecef;
  }

  .btn-primary {
    background-color: #122276;
    border-color: #122276;
  }

  .btn-primary:hover {
    background-color: #0056b3;
    border-color: #0056b3;
  }

  .dropdown-item, .dropdown-item:hover {
    color: #6c757d;
  }

  .page-item.active .page-link {
    background-color: #0056b3;
    border-color: #0056b3;
  }

}
.modal-open div[id^='modal-'] a {
  color: #0056b3;
  text-decoration: none;
}

.btn-primary {
  border-radius: 3px;
  background-color: #122276;
  border-color: #122276;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.btn-primary>.i-icon {
  vertical-align: middle;
  color: white;
}
</style>
